/**
 * The subset of @atlassian/conversation-assistant's SkillAttributes this package needs. Declared
 * locally (structurally compatible, not imported) to avoid a circular dependency, since
 * conversation-assistant depends on this package.
 */
export type MciKrSkillInput = {
	skillName: string | null;
	minionId: string;
};

/**
 * Flattens the agent/skill/plugin identifiers invoked this turn into a single scan-ordered list
 * for matching against MCI_KR_VIEW_KEY_CONFIG: agent, then skill (skillName, minionId), then
 * plugin, so earlier-scanned identifiers take priority.
 */
export const getMciKrIdentifiersFromSkillsAndPlugins = (
	skillsInvoked: MciKrSkillInput[],
	pluginsInvoked: Iterable<string>,
	agentExternalConfigReference?: string | null,
): string[] => [
	...(agentExternalConfigReference ? [agentExternalConfigReference] : []),
	...skillsInvoked.flatMap((skill) =>
		[skill.skillName, skill.minionId].filter((value): value is string => Boolean(value)),
	),
	...Array.from(pluginsInvoked),
];
